import React, { memo ,useRef,useState,useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {Placeholder,Modal} from 'react-bootstrap';


import { FreeMode, Navigation, Thumbs,Pagination  } from 'swiper/modules';
import { useCart } from './CartContext';
import NumberFormatter from "./NumberFormatter";
import AccordionSection from "./AccordionSection";
import UseMediaQuery from "./UseMediaQuery";
import Api from "./api";
import { useToast } from './ToastContext'; 

import 'swiper/css'; 
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import "bootstrap/dist/js/bootstrap.bundle.min";



const ProductDetail = memo(({ Product = [], loading }) => {
    const isMobile = UseMediaQuery("(max-width: 768px)");

    const { loadingProductId, handleAddToCart } = useCart();
    const thumbsSwiperRef = useRef(null);
    const [thumbsSwiper, setthumbsSwiper] = useState(false);
    const [selectedAttribute, setSelectedAttribute] = useState({});
    const {showMessage,showLoading } = useToast();
    const [showMailalertsModal, setShowMailalertsModal] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');

    
    const handleSelectattribute = (attr,location_code,price,additional_price) => {
        setSelectedAttribute({
            id_product_attribute : attr,
            loc_code: location_code,
            price: price,
            additional_price: additional_price && additional_price != null ? additional_price : 0
        });
    };
    const handleMailalert = async (Product) => {
         setShowMailalertsModal(false);
        const loadingToastId = showLoading("در حال انجام عملیات...");
        
        try{
            const response = await Api("emailalerts", { id_product: Product.id_product,id_product_attribute: Product.id_product_attribute, customer_email: phoneNumber },'POST');
            if(response && response.success==true){
                if (response && response.code == 200) {
                    showMessage('success', response.message, 3000, loadingToastId);
                }
                else if(response.code == 302){
                    showMessage('warning', response.message, 3000, loadingToastId);
                    setShowMailalertsModal(true);
                }
                else{                    
                    showMessage('error', response.message, 3000, loadingToastId);
                }
                
            }
           
        } catch (error) {
            console.error("API Error:", error);
           
           
        }
    }
    useEffect(() => {
        // ریست selectedAttribute در صورت تغییر محصول
        setSelectedAttribute({});
    }, [Product.id_product]);
  
    const [activeIndex, setActiveIndex] = useState(0);
    let selectattr = false;
    const zoomRef = useRef(null);

    const handleZoomMove = (e) => {
         let pageX, pageY;

        if (e.type === "mousemove") {
            pageX = e.pageX;
            pageY = e.pageY;
        } else if (e.type === "touchmove") {
            pageX = e.touches[0].pageX;
            pageY = e.touches[0].pageY;
        }
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((pageX - left) / width) * 100;
        const y = ((pageY - top) / height) * 100;

        const img = e.currentTarget.querySelector("img");
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = "scale(2)"; // میزان زوم
    };

    const handleZoomEnd = (e) => {
        const img = e.currentTarget.querySelector("img");
        img.style.transform = "scale(1)";
    };
    return(
       <>
        {loading?
            <div className="product-detail  mt-0 mt-md-5">
                {!isMobile ? (
                <div className='row container mx-auto px-0'>
                    
                    <div className="col-6">
                        <Placeholder as="h1" animation="glow">
                            <Placeholder xs={8} size="lg" />
                        </Placeholder>
                        <Placeholder className="price" animation="glow">
                            <Placeholder xs={5} size="lg" />
                        </Placeholder>
                        <div>
                        <Placeholder animation="glow">
                            <Placeholder xs={3} />
                        </Placeholder>
                        </div>
                        <Placeholder animation="glow">
                            <Placeholder.Button xs={8} className="btn add-to-cart mt-4 mx-4 p-3" />
                        </Placeholder>
                        <Placeholder animation="glow">
                            <Placeholder.Button xs={8} className="btn add-to-cart mt-3 mx-4 p-3" />
                        </Placeholder>
                    </div>
                    <div className="col-6 d-flex">
                        <div className="col-8 ms-2">
                            <div className="product-img-top">
                                <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                </Placeholder>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="product-img-top">
                                <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                </Placeholder>
                            </div>
                        </div>
                    </div>
                </div>):(
                    <>
                     <div className='row container m-0 px-0'>
                        <div className="col-12 p-0">
                            <div className="product-img-top">
                                <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                </Placeholder>
                            </div>
                        </div>
                    </div>
                    <div className='row container m-0 px-0'>
                        <div className="d-flex col-12 mt-3 w-100">
                            <Placeholder className="col-6 mx-1" animation="glow">
                                <Placeholder.Button xs={4} className="col-11 btn btn-plymouth-green border-0" />
                            </Placeholder>
                            <Placeholder className="col-6 mx-1" animation="glow">
                                <Placeholder.Button xs={4} className="col-11 btn btn-plymouth-green border-0" />
                            </Placeholder>
                        </div>
                        <div className="row container mt-3 mt-md-0">
                            <Placeholder className="product-title" animation="glow">
                                <Placeholder xs={5} />
                            </Placeholder>
                            <Placeholder className="price" animation="glow">
                                <Placeholder xs={4} />
                            </Placeholder>
                            <Placeholder className="price" animation="glow">
                                <Placeholder xs={3} />
                            </Placeholder>
                            
                        </div>
                    </div>
                    </>
                    )
                }
                <div className='add-to-cart-info p-4 text-center mt-5'>
                </div>
            </div>
            :
            <div className="product-detail mt-0 mt-md-5">
                {!isMobile ? (
                <div className='row container mx-auto px-0'>
                    
                    <div className="col-5">
                        <h1 className="product-title">{Product.name}</h1>
                       
                        <span className="price"><NumberFormatter className='ms-2' 
                        amount={isNaN(selectedAttribute.price)
                            ? (isNaN(Product.price) ? 0 : Product.price)
                            : selectedAttribute.price
                        } locale ='en-us'/> ریال</span>
                       
                        {(Product.webhesab_ojrate.ojrat < 60) && (
                            <div style={{fontSize:'24px',fontWeight:'700',lineHeight:'29px',opacity:'.65'}}>% <span style={{letterSpacing:'16%',marginLeft:'15px'}}>{Product.webhesab_ojrate.ojrat}</span>  اجرت ساخت</div>
                        )}
                        {selectedAttribute.additional_price!=0 &&
                            <div style={{fontSize:'24px',fontWeight:'700',lineHeight:'29px',opacity:'.65'}}> <span style={{marginLeft:'15px'}}>{selectedAttribute.additional_price}</span>  متعلقات</div>
                        }

                        <div className="d-flex flex-column col-9 mt-4 w-100">
                            <button className="btn btn-outline text-center m-2 p-3 mobile-image"  data-bs-toggle="modal" data-bs-target="#galleryModal">برای مشاهده عکس با موبایل کلیک کنید</button>
                           
                            <button className="btn btn-outline text-center m-2 p-3 mobile-image" data-bs-toggle="modal" data-bs-target="#videoModal">برای مشاهده ویدیو با موبایل کلیک کنید</button>
                        </div>
                    </div>
                   
                    <div className="col-7 d-flex">
                        {/* اسلایدر اصلی */}
                        <div className="col-10 ms-2">
                        <Swiper
                           
                            
                            spaceBetween={0}
                            thumbs={{
                                swiper:
                                thumbsSwiperRef.current &&
                                !thumbsSwiperRef.current.destroyed
                                    ? thumbsSwiperRef.current
                                    : null,
                            }}
                            navigation={true} 
                            modules={[FreeMode, Navigation, Thumbs]}
                            lazy={{ loadPrevNext: true }} // فعال کردن Lazy Load
                            className="mainSwiper"
                           
                        >
                            {Product.images &&
                            Product.images.map((image, index) => (
                                <SwiperSlide key={index}
                                onMouseMove={handleZoomMove}
                                onMouseLeave={handleZoomEnd}
                                style={{
                                overflow: "hidden",
                                cursor: "zoom-in",
                                }}
                                >
                                <img
                                    src={image.src}
                                    alt={`Product Image ${index}`}
                                    className="swiper-lazy"
                                    style={{
                                    width: "100%",
                                    height: "auto",
                                    cursor: "pointer",
                                    }}
                                />
                                 <div className="swiper-lazy-preloader"></div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        </div>
                        <div className="col-2">
                        {/* اسلایدر Thumbnail */}
                        
                        <Swiper
                            direction="vertical"
                            slidesPerView={5} // تعداد اسلایدهای قابل نمایش
                            spaceBetween={10} // فاصله بین اسلایدها
                            freeMode={true}
                            onSwiper={(swiper) => {
                                thumbsSwiperRef.current = swiper;
                                setthumbsSwiper(swiper);
                            }}
                            modules={[FreeMode, Navigation, Thumbs]}
                            lazy={{ loadPrevNext: true }}
                            className="thumbSwiper"
                        >
                        {Product.images &&
                            Product.images.map((image, index) => (
                                <SwiperSlide key={index} >
                                <img
                                    src={image.src}
                                    alt={`Thumbnail ${index}`}
                                    className="swiper-lazy"
                                    style={{
                                    width: "100%",
                                    height: "auto",
                                    cursor: "pointer",
                                    }}
                                />
                                 <div className="swiper-lazy-preloader"></div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        </div>
                    </div>
                </div>
                ):( //موبایل
                    <> 
                    <div className='row container m-0 px-0'>
                        <div className="col-12 p-0">
                            <Swiper
                            slidesPerView={1}
                            modules={[FreeMode, Navigation,Pagination]}
                            pagination={{ clickable: true }}
                             navigation={true} 
                            lazy={{ loadPrevNext: true }} // فعال کردن Lazy Load
                            className="mainSwiper"
                            >
                                {Product.images &&
                                Product.images.map((image, index) => ( 
                                    <SwiperSlide key={index}
                                        onTouchMove={handleZoomMove}
                                        onTouchEnd={handleZoomEnd}
                                    >
                                    <img
                                        src={image.src}
                                        alt={`Product Image ${index}`}
                                        className="swiper-lazy"
                                        style={{
                                        width: "100%",
                                        height: "auto",
                                        cursor: "pointer",
                                        }}
                                    />
                                    <div className="swiper-lazy-preloader"></div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                    <div className='container m-0 px-0'>
                            <div className="d-flex col-12 mt-2">
                                <button className="btn btn-plymouth-green text-center m-2 px-4 p-md-3" data-bs-toggle="modal" data-bs-target="#galleryModal">برای مشاهده عکس با موبایل کلیک کنید</button>
                                <button className="btn btn-plymouth-green text-center m-2 px-4 p-md-3" data-bs-toggle="modal" data-bs-target="#videoModal">برای مشاهده ویدیو با موبایل کلیک کنید</button>
                            </div>
                        <div className="col-12 p-3 m-md-0">
                            <h1 className="product-title">{Product.name}</h1>
                            
                            <span className="price"><NumberFormatter className='ms-2'  
                            amount={isNaN(selectedAttribute.price)
                                ? (isNaN(Product.price) ? 0 : Product.price)
                                : selectedAttribute.price
                            } locale ='en-us'/> ریال</span>
                              {(Product.webhesab_ojrate.ojrat < 60) && (
                            <div className='ojrat'>% {Product.webhesab_ojrate.ojrat} <span>اجرت ساخت</span></div>
                              )}
                            {selectedAttribute.additional_price!=0 &&
                                <div className='ojrat'>{selectedAttribute.additional_price} <span>متعلقات</span></div>
                            }
                        </div>
                   
                    </div>
                    </>
                    )
                }
                
                <div className='add-to-cart-info p-4 text-center'>
                {Product.quantity > 0 ? (
                    <button 
                    className='btn add-to-cart'
                    onClick={() => handleAddToCart({
                        id_product : Product.id_product,
                        id_product_attribute : selectedAttribute.id_product_attribute,
                        loc_code:selectedAttribute.loc_code
                      })}
                    disabled={loadingProductId === Product.id_product}
                    >
                    {loadingProductId === Product.id_product && (
                        <span
                            className="spinner-border spinner-border-sm mx-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    )}
                    افزودن به سبد خرید
                    </button>
                ):(
                    <button 
                    className='btn add-to-cart'
                    onClick={() => handleMailalert({
                        id_product : Product.id_product,
                        id_product_attribute : selectedAttribute.id_product_attribute,
                      })}
                    disabled={loadingProductId === Product.id_product}
                    >
                    {loadingProductId === Product.id_product && (
                        <span
                            className="spinner-border spinner-border-sm mx-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    )}
                    موجود شد به من اطلاع بده
                    </button>
                )
                }
             

                {Object.values(Product.groups).map((group, group_id) => (
                <div key={group_id} className="clearfix product-variants-item">
                  
                    {group.group_type === "select" ? (
                    <>
                        <h2 className="mt-4">موجودی شعب</h2>
                        <table className='attribute-ts mb-4'>
                        <thead>
                            <tr>
                            <th>انتخاب</th>
                            <th>وزن</th>
                            {Product.webhesab_addition_info.size && (
                                <th>سایز</th>
                            )}
                            <th>قیمت (ریال)</th>
                            <th>نام فروشگاه</th>
                            </tr>
                        </thead>
                        <tr className='space-tb'>
                            <td colSpan={4} ></td>
                        </tr>
                        <tbody>
                        
                        {Object.values(Product.webhesab_addition_info.references).map((reference,refindex)=>{
                           
                                if (["", 1, 6, 8].includes(Product.webhesab_addition_info.locations_code[reference])) {
                                    return null;
                                }
                               
                                if(selectedAttribute.id_product_attribute){
                                    selectattr = (selectedAttribute.id_product_attribute === Product.webhesab_addition_info.pr_attr[reference]);
                                }
                                else if(Product.webhesab_addition_info.atr[reference] == group.default){
                                        selectattr = true;
                                        
                                        setSelectedAttribute({
                                            id_product_attribute : Product.webhesab_addition_info.pr_attr[reference],
                                            loc_code: Product.webhesab_addition_info.locations_code[reference],
                                            price:Product.webhesab_addition_info.price[reference],
                                            additional_price:  Product.webhesab_ojrate?.additional_price?.[reference] ?? 0
                                        });
                                        //handleSelectattribute(Product.webhesab_addition_info.pr_attr[reference],Product.webhesab_addition_info.locations_code[reference], Product.webhesab_addition_info.price[reference]);  
                                }
                                return (
                                    <tr key={refindex} onClick={() => handleSelectattribute(Product.webhesab_addition_info.pr_attr[reference],Product.webhesab_addition_info.locations_code[reference], Product.webhesab_addition_info.price[reference],Product.webhesab_ojrate?.additional_price?.[reference] ?? 0)}>
                                        <td> 
                                            <input
                                                type="radio"
                                                value={Product.webhesab_addition_info.pr_attr[reference]} 
                                                name="group"
                                                onChange={() => handleSelectattribute(Product.webhesab_addition_info.pr_attr[reference],Product.webhesab_addition_info.locations_code[reference],Product.webhesab_addition_info.price[reference],Product.webhesab_ojrate?.additional_price?.[reference] ?? 0)}
                                                checked={selectattr}
                                            />
                                        </td>
                                       
                                        <td style={{letterSpacing:'16%'}} className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            {Product.webhesab_addition_info.products_wight[reference]} 
                                        </td>
                                        {Product.webhesab_addition_info.size && (
                                        <td className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            {Product.webhesab_addition_info.size[reference]} 
                                        </td>)}
                                        <td style={{letterSpacing:'16%'}} className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            <NumberFormatter amount={Product.webhesab_addition_info.price[reference]} locale="en-US" />
                                        </td>
                                        <td className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            {Product.webhesab_addition_info.locations_name[reference]}
                                        </td>
                                    </tr>
                                );
                            }
                        )}
                        </tbody>
                        </table>
                    </>
                    ) : (
                    <div></div>
                    )}
                </div>
                ))}
                </div>
                <div className='product-desc mx-auto mt-5'>
                    <AccordionSection title="توضیحات">
                        {Product.description}
                    </AccordionSection>
                    <AccordionSection title="نحوه محاسبه قیمت">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                (نرخ طلای روز +۷٪ سود + اجرت
                                <br/>
                                - نرخ طلای روز + ۱۰٪مالیات +  نرخ طلای روز)
                                <br/>
                                *وزن طلا+                                (قیمت متعلقات + ۱۰٪ مالیات)
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                    <AccordionSection title="زمان ارسال">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال محصولات در شهر تهران از طریق پیک یا پست(به تشخیص دفتر مرکزی)انجام میگردد.کلیه ارسال ها از محدوده قیطریه انجام میشود.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال از شعب تهران به آدرس تهران ۲۴ الی ۷۲ ساعت کاری انجام میگردد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال از تهران به شهرستان هر یکشنبه و چهارشنبه با پست(در صورتی که سفارش ۴۸ ساعت قبل از روزهای ذکر شده ثبت شده باشد.)
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال از شعبه کرج به دیگر استان ها حدود دو هفته زمان میبرد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                مسئولیت ارسال های پستی با خریدار میباشد.
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                    <AccordionSection title="هزینه ارسال">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال سفارشات بالای ۲۰ میلیون تومان
                                رایگان می باشد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                مسئولیت ارسال های پستی با خریدار میباشد.
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                    <AccordionSection title="شرایط تعویض و مرجوعی کالا">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                پس از ثبت سفارش امکان مرجوعی کالا وجود ندارد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                تعویض کالا تا ۲۴ ساعت بدون کسر از مبلغ فاکتور تا ۵ روز با کسر سود و مالیات بر ارزش افزوده انجام میگردد و پس از اتمام مدت مذکور کالا به صورت طلای خام از مشتری خریداری میگردد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                سفارش شهرستان شامل قوانین تعویض کالا نمی باشد.
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                </div>
                <div className="modal fade" id="galleryModal" tabIndex="-1" aria-labelledby="galleryModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="galleryModalLabel">گالری</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                            {/* اسلایدر Swiper داخل مودال */}
                            <Swiper
                                initialSlide={activeIndex}
                                navigation
                                pagination={{ clickable: true }}
                                modules={[Navigation, Pagination]}
                                className="swiper-container"
                            >
                                
                                {Product.size_chart && Object.entries(Product.size_chart).map(([key, size],index)=>{
                                    return(
                                        <SwiperSlide key={index}>
                                        
                                                <div dangerouslySetInnerHTML={{ __html: size.content }} />
                                        
                                            {/*<img src={item.src} alt={`مدیا ${i + 1}`} className="img-fluid w-100" />*/}
                                            
                                        </SwiperSlide>);
                                    })
                                }
                            </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="videoModal" tabIndex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="videoModalLabel">ویدیو</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{textAlign:"center"}}>
                                
                                {Product.video && Object.entries(Product.video).map(([key, video],index)=>{
                                    
                                    return(
                                    <video width="640" height="360" controls>
                                    <source src={video.url} type="video/mp4" />
                                    مرورگر شما تگ ویدیو را پشتیبانی نمی‌کند.
                                    </video>
                                    );
                                  })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={showMailalertsModal} onHide={() => setShowMailalertsModal(false)} centered size="lg">
                    <Modal.Header>
                        <Modal.Title>شماره موبایل خود را وارد کنید</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{textAlign:"center"}}>
                         <input
                            type="tel"
                            className="form-control"
                            placeholder="09xxxxxxxxx"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            style={{ maxWidth: "300px", margin: "0 auto" }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                    <button className='btn' variant="primary" onClick={() => handleMailalert({
                        id_product : Product.id_product,
                        id_product_attribute : selectedAttribute.id_product_attribute,
                      })}>
                        ارسال
                    </button>
                    </Modal.Footer>

                </Modal>
            </div>

        }
       </>
    );
});
export default ProductDetail;